module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-101-900-normal.f1a876d.woff2";